import {
  AuthenticationResult,
  Configuration,
  EventType,
  PublicClientApplication,
  RedirectRequest,
} from '@azure/msal-browser';
import Config from '../config';

const tenantId = Config.TENANT_ID || 'common';
const authority = `https://login.microsoftonline.com/${tenantId}`;

export const apiScope = `api://${Config.API_CLIENT_ID}/user_impersonation`;
export const emkitScope =
  'https://EMCloudAD.onmicrosoft.com/a4c25b63-664a-45ef-b58c-fc63c326200e/access:emkit';

export const msalConfig: Configuration = {
  auth: {
    clientId: Config.CLIENT_ID,
    authority,
    redirectUri: Config.REDIRECT_URI,
    // Required behind the ExxonMobil corporate proxy to skip instance discovery.
    knownAuthorities: ['login.microsoftonline.com'],
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

const cachedAccounts = msalInstance.getAllAccounts();
if (cachedAccounts.length > 0) {
  msalInstance.setActiveAccount(cachedAccounts[0]);
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const { account } = event.payload as AuthenticationResult;
    if (account) {
      msalInstance.setActiveAccount(account);
    }
  }
});

// Sign-in request: SSO via the ExxonMobil domain hint; consent the EMKit scope alongside the API scope.
export const loginRequest: RedirectRequest = {
  scopes: [apiScope],
  extraScopesToConsent: [emkitScope],
  extraQueryParameters: { domain_hint: 'exxonmobil.com' },
};
